import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';
import { getOrigin } from '../getOrigin';
import { parseXml } from '../parseXml';

// https://sc-mirror.shoutca.st/docs/DNAS_Server_XML_Responses.html#General_Server_Summary
interface ShoutcastMetadata {
  CURRENTLISTENERS?: string;
  PEAKLISTENERS?: string;
  MAXLISTENERS?: string;
  UNIQUELISTENERS?: string;
  AVERAGETIME?: string;
  SONGTITLE?: string;
  NEXTTITLE?: string;
  STREAMHITS?: string;
  STREAMSTATUS?: string;
  BACKUPSTATUS?: string;
  STREAMLISTED?: string;
  STREAMLISTEDERROR?: string;
  STREAMSOURCE?: string;
  STREAMBACKUP?: string;
  STREAMUPTIME?: string;
  STREAMPATH?: string;
  BITRATE?: string;
  CONTENT?: string;
  VERSION?: string;
}

export const fetchStats = async ({
  url,
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    url: `${getOrigin(url)}/stats`,
    parser: async (response) => {
      const text = await response.text();
      const { SONGTITLE: title } = parseXml<ShoutcastMetadata>(text);

      return title;
    }
  });
};
